import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { parseJwt } from 'src/app/utilities/fn';

@Injectable()
export class AuthService {

  private user: any = null;
  private account: any = null;

  constructor(private http: HttpClient, private router: Router, private readonly oauthService: OAuthService) {

  }

  getClaims(): any {
    // return this.user.profile;
  }

  getPermissions(): any {
    return this.account;
  }

  getAuthorizationHeaderValue(): string {
    return this.oauthService.getAccessToken() ? `Bearer ${this.oauthService.getAccessToken()}` : '';
  }

  getAccessTokenValue(): string {
    return this.oauthService.getAccessToken();
  }

  getUserName(): string {
    const tokenData = parseJwt(this.oauthService.getAccessToken());
    return tokenData.preferred_username;
  }

  getUserId(): string {
    const tokenData = parseJwt(this.oauthService.getAccessToken());
    return tokenData.sub;
  }

  isExpired(): boolean {
    return this.user.expired;
  }

  getUserImage(): string {
    return localStorage.getItem('avatarUrl') || '';
  }

  getEmpDetail() {
    if (this.user) {
      const options = {
        headers: new HttpHeaders({
          Authorization: `${this.user.token_type} ${this.user.access_token}`
        })
      };
      //
      // this.getAccountLogin(options).subscribe(result => {
      //   if (result) {
      //     this.account = result;
      //     localStorage.setItem('account', JSON.stringify(this.account));
      //     const returnUrl = localStorage.getItem('returnUrl');
      //     if (returnUrl) {
      //       this.router.navigateByUrl(returnUrl);
      //     }
      //   }
      // });
    }
  }


  getAccount() {
    // if (this.user) {
    //   const options = {
    //     headers: new HttpHeaders({
    //       Authorization: `${this.user.token_type} ${this.user.access_token}`
    //     })
    //   };
    //
    //   this.getAccountLogin(options).subscribe(result => {
    //     if (result) {
    //       this.account = result;
    //       localStorage.setItem('account', JSON.stringify(this.account));
    //     }
    //   });
    // }
  }

  // getAccountLogin(options: any): Observable<any> {
  //   return this.http.post(`${apiYamahaBaseUrl}/api/v1/account/Login`, {}, options);
  // }
}
